import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Row,
    Col
} from 'react-bootstrap';
import Translator from '../translates/Translator';

// Children -> inner text as html part, should be able to show <ul> and <p>
const ServiceDescriptionPanel = ({ children, imgOnLeft, title, subtitle, img, path }) => {
    const t = Translator();
    const [expanded, setExpanded] = useState(false);

    const textCol = (
        <Col className="col-text d-flex flex-column">
            {title && <h3 className="mb-4 service-panel-title primary">{title}</h3>}
            {subtitle && <p className='text-notes'>{subtitle}</p>}
            <Row className='btn-row ms-0 mt-2 mt-lg-3 mt-xl-4 justify-content-start column-gap-4'>
                <button onClick={() => setExpanded(!expanded)} className="btn col-5 col-md-3" >
                    {expanded ? t('show-less') : t('show-more')}
                    {expanded ? <i className="ms-2 fa-solid fa-angle-up"></i> : <i className="ms-2 fa-solid fa-angle-down"></i>}
                </button>
                {path && <a href={path} className="btn col-5 col-md-5">{t('full-detail')}<i className="ms-2 fa-solid fa-angle-right"></i></a>}
            </Row>
        </Col>
    );

    const imageCol = (
        <Col xs={3} md={4} className="text-center col-img">
            {img}
        </Col>
    );

    return (
        <div className="service-panel">
            <Row className='br-4' >
                {imgOnLeft ? (
                    <>
                        {imageCol}
                        {textCol}
                    </>
                ) : (
                    <>
                        {textCol}
                        {imageCol}
                    </>
                )}
            </Row>
            <div className={`panel-detail ${expanded ? "expanded" : ""}`}>
                <div className="panel-detail-inner">
                    {children}
                </div>
            </div>
        </div>
    );
}

export default ServiceDescriptionPanel;